import styled from 'styled-components';

export const Background = styled.div`
  width: 100%;
  height: 100%;
  background: #ffffffb7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoadingText = styled.div`
  font: 1rem 'Noto Sans KR';
  text-align: center;
  color: #efac59;
`;
